import { AppError } from './AppError';
import { ThrowExtras, createError } from './factories';
import { isAppError } from './guards';

export function wrapError(
  error: unknown,
  code: string,
  message: string,
  extra?: Omit<ThrowExtras, 'cause'>,
): AppError {
  if (isAppError(error)) {
    return error;
  }

  return createError(code, message, {
    ...extra,
    cause: error,
  });
}
